// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._2LtiBs0QFy0T6xn0SS2W3x {\n    display: flex;\n    flex-direction: column;\n    font-family: Helvetica serif;\n  }\n  ._6Z9YH7Qxp_AWrunyTXjc7 {\n    width: 8in;\n    height: 10.5in;\n    display: flex;\n    flex-direction: column;\n    margin-left: auto;\n    margin-right: auto;\n    border-bottom: 1px solid black;\n    padding: 0.25in;\n  }\n  @media print {\n    ._6Z9YH7Qxp_AWrunyTXjc7 {\n      border-bottom: none !important;\n    }\n  }\n  ._16g_MaPE_LtUpqw4wDWuQu {\n    width: 8in;\n    display: flex;\n    flex-direction: column;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0.25in;\n  }\n", ""]);
// Exports
exports.locals = {
	"print": "_2LtiBs0QFy0T6xn0SS2W3x",
	"page": "_6Z9YH7Qxp_AWrunyTXjc7",
	"pages": "_16g_MaPE_LtUpqw4wDWuQu"
};
module.exports = exports;
